import React, { ReactNode } from 'react';

import { isString } from 'lodash-es';
import { useIntl } from 'react-intl';

import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';

import { CheckoutErrorCellContainer, Dot, ErrorText } from './styled';

interface ICheckoutErrorsModalProps {
  showDot?: boolean;
  checkoutErrorId: string;
  message?: string | ReactNode;
}

const CheckoutErrorCell: React.FC<React.PropsWithChildren<ICheckoutErrorsModalProps>> = ({
  showDot = false,
  checkoutErrorId,
  message,
}) => {
  const { formatMessage } = useIntl();

  const messageForDisplay = message || formatMessage({ id: checkoutErrorId });

  // message can be JSX dont attempt to log this
  const errorMessageForLogging = isString(messageForDisplay)
    ? messageForDisplay
    : 'unknown-checkout-error';
  useLogUserErrorMessage({
    message: errorMessageForLogging,
    severity: LogUserErrorSeverity.Recoverable,
    context: {
      errorMessageId: checkoutErrorId,
    },
  });

  return (
    <CheckoutErrorCellContainer>
      {showDot && <Dot testID="checkout-error-dot" />}
      <ErrorText>{messageForDisplay}</ErrorText>
    </CheckoutErrorCellContainer>
  );
};

export default CheckoutErrorCell;
